import $ from 'jquery';
import Component from './Component';
import { pluginFactory, getPluginAPI } from './Plugin';

// require available plugins
import { Menu } from './Plugin/menu';
import { Scrollable } from './Plugin/asscrollable';
import { Panel } from './Plugin/panel';
import { FormMaterial } from './Plugin/material';
import { Select2 } from './Plugin/select2';
import { Flatpickr } from './Plugin/flatpickr';
import { Validate } from './Plugin/jquery-validate';

export default class extends Component {
  initializePlugins(context = false) {
    $('[data-plugin]', context || this.$el).each(function () {
      let $this = $(this),
        name = $this.data('plugin'),
        plugin = pluginFactory(name, $this, $this.data());
      if (plugin) {
        plugin.initialize();
      }
    });
  }

  initializePluginAPIs(context = document) {
    let apis = getPluginAPI();

    for (let name in apis) {
      getPluginAPI(name)(`[data-plugin=${name}]`, context);
    }
  }

  initializeEventListeners(context = document) {
    context.addEventListener('remark.plugin.initialize', event => {
      if (typeof event.detail !== 'undefined' && event.detail.hasOwnProperty('context')) {
        const context = event.detail.context.hasAttribute('data-plugin') ? $(event.detail.context).parent() : $(event.detail.context);
        this.initializePlugins(context);
      }
    });
  }
}
